function getCountry() {
  return fetch('https://ipinfo.io/json?token=9c99f7d16e04e6')
    .then(response => response.json())
    .then((response) => {
      const result = response;
      return result.country;
    });
}

export default getCountry;
